import {ILocationService, IRootScopeService} from "angular";
import {Autentisering} from "felles/tjenester/Autentisering";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {Debugger} from 'debug'
import {l} from "../../types/typescriptdefinisjoner_lederplan";
import {Kontekst} from "felles/tjenester/Kontekst";
import {StateService, TransitionService} from "@uirouter/angularjs";
import {Utlogging} from "./Utlogging";

const debug: Debugger = require('debug')('Innlogging');

export class Innlogging {

    static regNavn = "wt.Innlogging";

    static forInjisering() {
        return [
            regNavn.ng.$rootScope,
            regNavn.ng.$browser,
            regNavn.ng.$location,
            regNavn.ng.ui.$state,
            regNavn.ng.ui.$transitions,
            Kontekst.regNavn,
            Autentisering.regNavn,
            WebNavigasjon.regNavn,
            Utlogging.regNavn,
            Innlogging
        ];
    }

    constructor(private $rootScope: IRootScopeService,
                private $browser,
                private $location: ILocationService,
                private $state: StateService,
                private $transitions: TransitionService,
                private kontekst: Kontekst,
                private autentisering: Autentisering,
                private navigasjon: WebNavigasjon,
                private utlogging: Utlogging) {
    }

    private avbrytNavLytter: Function;

    initHåndterTokenfornyelse() {
        this.$rootScope.$on(Autentisering.brukerAutentisertEvent, () => {
            this.vedLogut(); //nødvendig ifbm oppgradering fra kort til medium token

            switch (this.kontekst.aktivtTokenInfo().tokenvarighet) {
                case l.Tokenvarighet.kort:
                    this.vedBrukerAutentisertMedKortToken();
                    break;
                case l.Tokenvarighet.medium:
                    this.vedBrukerAutentisertMedMediumToken();
                    break;
            }
        });

        this.$rootScope.$on(Autentisering.brukerLoggetUtEvent, () => {
            this.vedLogut();
        });
    }

    /** varlse og logge ut bruker etter for lang inaktivitet,
     *  samt periodisk forny token så lenge bruker er aktiv */
    private vedBrukerAutentisertMedKortToken() {
        debug("håndter bruker autentisert med KORT token");
        //start timer som varsler/logger ut
        this.utlogging.startLoggUtEtterInaktivitetTimer();

        //håndter token fornyels så lenge bruker er aktiv
        this.autentisering.startAutomatiskKortTokenfornyelse();
    }

    /** Gå til innloggingssiden dersom tokenet nærmer seg utløp. */
    private vedBrukerAutentisertMedMediumToken() {
        debug("håndter bruker autentisert med MEDIUM token");
        //sjekk den lange fristen ved autentisering
        this.autentisering.reautentiserDersomTokenUtløperSnart(
          'fristVedAutentisering',
          () => this.navigasjon.gåTilInnloggingssiden(this.$location.url()));

        //sjekk den korte fristen ved navigasjon
        this.avbrytNavLytter = this.$transitions.onBefore({}, trans => {
            const måReautentisere = this.autentisering.reautentiserDersomTokenUtløperSnart(
              'fristVedNavigasjon',
              () => this.navigasjon.gåTilInnloggingssiden(this.$location.url()));
            //returnerer false dersom bruker må reautentiserer - noe som vil avbryte transition
            return !måReautentisere;
        });
    }

    private vedLogut() {
        //relevant for kort token
        this.utlogging.stoppLoggUtEtterInaktivitetTimer();
        this.autentisering.stoppAutomatiskKortTokenfornyelse();

        //relevant for medium token
        if (!this.avbrytNavLytter) return;
        this.avbrytNavLytter();
    }
}
